import { FETCH_OFFER_TYPES_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const offerTypesListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OFFER_TYPES_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default offerTypesListReducer;
